import axios from 'axios'
import {
    FETCH_CAR,
    FETCH_CARS,
    ADD_CAR,
    APIpath,
    setRedirect,
    addToast
} from '../actions'

const setCars = (cars) => ({
    type: FETCH_CARS,
    cars
})

const setCar = (car) => ({
    type: FETCH_CAR,
    car
})

const addCar = (car) => ({
    type: ADD_CAR,
    car
})

export const fetchCars = () => (dispatch) => {
    dispatch(setRedirect(false))
    axios.get(`${APIpath}/carro`)
        .then(function (response) {
            dispatch(setCars(response.data))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const saveCar = (values) => dispatch => {
    axios.post(`${APIpath}/carro/store`, values)
        .then(function (response) {
            dispatch(addCar(response.data))
            dispatch(addToast('success', 'Carro creado'))
            dispatch(setRedirect(true))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const updateCar = (values) => dispatch => {
    axios.post(`${APIpath}/carro/update`, values)
        .then(function (response) {
            dispatch(setCar(response.data[0]))
            dispatch(addToast('success', 'Carro actualizado'))
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}

export const carImage = (values) => (dispatch) => {
    axios.post(`${APIpath}/carro/image/store`, values)
        .then(function (response) {
            dispatch(addToast('success', 'Imagen guardada'))
            setTimeout(() => {
                window.location.reload(false);

            }, 1000)
        })
        .catch(function (err) {
            dispatch(addToast('error', 'El proceso ha fallado'))
        })
}